import Vue from 'vue';
import Subscriptions from './components/Subscriptions'
import Questions from './components/Questions'
import VueCurrencyFilter from 'vue-currency-filter'

Vue.use(VueCurrencyFilter, {
  symbol : '£',
  thousandsSeparator: ',',
  fractionCount: 2,
  fractionSeparator: '.',
  symbolPosition: 'front',
  symbolSpacing: false
})

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('#subscription-builder')) {
    new Vue({
      el: '#subscription-builder',
      components: {
        Subscriptions,
        Questions
      }
    })
  }
})